<template> 

    <div class="main_lay">

        <!-- 首页第一列 -->
        <v-row>
            <v-col cols="12" md="3">
                <material-stats-card
					color="cyan lighten-2"
					icon="mdi-access-point-network "
					:title="$vuetify.lang.t('$vuetify.dashboard.firstTitle1')"
					:value="firstValue1"
					sub-icon="mdi-tag"
					:sub-text="$vuetify.lang.t('$vuetify.dashboard.firstText1')"
				/>
            </v-col>
			<v-col cols="12" md="3">
				<material-stats-card
					color="blue lighten-2"
					icon="mdi-access-point"
					:title="$vuetify.lang.t('$vuetify.dashboard.firstTitle2')"
					:value="firstValue2"
					sub-icon="mdi-tag"
					:sub-text="$vuetify.lang.t('$vuetify.dashboard.firstText2')"
				/>
			</v-col>
			<v-col cols="12" md="3">
				<material-stats-card
					color="deep-purple lighten-2"
					icon="mdi-account-group-outline"
					:title="$vuetify.lang.t('$vuetify.dashboard.firstTitle3')"
					:value="firstValue3"
					sub-icon="mdi-tag"
					:sub-text="$vuetify.lang.t('$vuetify.dashboard.firstText3')"
				/>
			</v-col>
			<v-col cols="12" md="3">
				<material-stats-card
					color="indigo lighten-2"
					icon="mdi-devices"
					:title="$vuetify.lang.t('$vuetify.dashboard.firstTitle4')"
					:value="firstValue4"
					sub-icon="mdi-tag"
					:sub-text="$vuetify.lang.t('$vuetify.dashboard.firstText4')"
				/>
			</v-col>
        </v-row>

        <!-- 第二列 -->
        
        <v-row>
            <v-col cols="12" md="12">
                <v-card
                class="pa-2"
                outlined
                tile
                >
                <v-card-title style="font-size: 16px;
                    color: #9AA4AF;
                    font-weight: normal;
                    padding: 7px 0 10px 23px;
                    pointer-events: none;">
                {{$vuetify.lang.t('$vuetify.dashboard.secondLineTitle')}}
                    
                </v-card-title>

                    <v-row
                        align="center"
                        class="mx-0"
                    >
                        <div id="myChart2" :style="{width: '100%', height: '300px',top:'0'}"></div>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!-- 用户认证趋势图 -->

      <v-row>
        <v-col cols="12" md="12">
          <v-card
              class="pa-2"
              outlined
              tile
          >
            <v-card-title style="font-size: 16px;
                    color: #9AA4AF;
                    font-weight: normal;
                    padding: 7px 0 10px 23px;
                    pointer-events: none;">
              {{$vuetify.lang.t('$vuetify.dashboard.secondLineTitle')}}

            </v-card-title>
            <v-row>
              <el-date-picker
                  style="margin-left: 10%"
                  v-model="authtime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="chartTimeChange">
              </el-date-picker>
              <el-select v-model="groups_id" placeholder="请选择集团" @change="chartTimeChange">
                <el-option
                    v-for="item in group"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </v-row>
            <v-row
                align="center"
                class="mx-0"
            >
              <div id="myChart3" :style="{width: '100%', height: '300px',top:'0'}"></div>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
<!--  连接数统计-->
  <v-row>
    <v-col cols="12" md="12">
      <v-card
          class="pa-2"
          outlined
          tile
      >
        <v-card-title style="font-size: 16px;
                    color: #9AA4AF;
                    font-weight: normal;
                    padding: 7px 0 10px 23px;
                    pointer-events: none;">
          {{$vuetify.lang.t('$vuetify.dashboard.contectLineTitle')}}

        </v-card-title>
        <v-row>
          <el-date-picker
              style="margin-left: 10%"
              v-model="connecttime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="ConnectTimeChange">
          </el-date-picker>
          <el-select v-model="group_id" placeholder="请选择集团" @change="ConnectTimeChange">
            <el-option
                v-for="item in group"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                >
            </el-option>
          </el-select>
        </v-row>
        <v-row
            align="center"
            class="mx-0"
        >
          <div id="myChart4" :style="{width: '100%', height: '300px',top:'0'}"></div>
        </v-row>
      </v-card>
    </v-col>
  </v-row>

  </div>

</template>

<script>
import Echarts from 'echarts'
import countTo from 'vue-count-to'
import * as api from '../../api'
import {Notification} from "element-ui";

export default {
    components: { countTo },
    data () {
        return {
            authtime: '',
            connecttime: '',
            pickerOptions: {
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            devcode: '',
            devcodelist: {},
          group: [],
          group_id: '',
          groups_id: '',
          firstValue1: '',
            firstValue2: '',
            firstValue3: '',
            firstValue4: '',
            toggle_exclusive: 2,
            chart2_series: [],
            
            subIcon: undefined,
            subIconColor: undefined,
            subTextColor: undefined,
            subText: undefined,
            color: 'red',

            count1_1: 0,
            count1_2: 0,
            top3: [],
            count2_1: 0,
            unit: 'B',
            count2_2: 0,
            count2_3: 0,
            count4_1: 0,
            Total:10,

            icon: 'mdi-bell-outline',
            warning_smallValue: null,
            warning_subIcon: 'mdi-alert',
            warning_value: 0,
            gaugeData: [],

            chart2: null,
            chart5: null,
            chart6: null,
            chart7: null,
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.drawPart1()
            this.drawPart2()
            this.drawPart3()
            // this.drawPart4()
            // this.getDevcodelist()
            this.getGroup()
            // this.drawChart3_all()
            // this.drawChart4_all()
            // this.drawPart5()

        })
        
        window.onresize = () => {
            this.chart2.resize();
            // this.chart5.resize();
            // this.chart6.resize();
            // this.chart7.resize();
        }

        
    },
    methods: {
        bytesToSize(bytes) {
            if (bytes === 0) return '0 B';
            var k = 1000, // or 1024
                sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
        
            return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + (i>0?sizes[i]:'');
        },
        getDevcodelist() {
          this.$http.get(api.default.dashboard.getDev).then(resp => {
            if(resp){

              this.devcodelist= resp.data
            }

          }).finally(resp => {
            this.loading = false
          })
        },
      getGroup () {
        this.$http.post(api.default.rbac.groupListUrl).then(resp => {
          // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
          if (!resp) return;
          this.group = resp.data;
        })
      },
        drawPart1(){
            this.$http.get(api.default.dashboard.index).then(resp => {
                if(resp){

                    this.firstValue1= resp.data.gateway_on + '|' + resp.data.gateway_all
                    this.firstValue2= resp.data.user + ''
                    this.firstValue3= resp.data.user_max + ''
                    this.firstValue4= resp.data.register_count + ''
                }else{
                    this.firstValue1= '/'
                    this.firstValue2= "/"
                    this.firstValue3= "/"
                    this.firstValue4= "/"
                }

            }).finally(resp => {
                this.loading = false
            })
            
        },
        drawPart2(){

            let myChart = Echarts.init(document.getElementById('myChart2'))
            this.chart2 = myChart

            this.$http.post(api.default.dashboard.hourauth).then(resp => {
                if(!resp) return
                let data = []
                let xAxis = []
                if(resp.data.length){
                    for (let index = 0; index < resp.data.length; index++) {
                        data.push(parseInt(resp.data[index]['count']))
                        xAxis.push(resp.data[index]['date'])
                    }
                    myChart.setOption({
                        backgroundColor: '#FFF',
                        grid: {
                            top: '9%',
                            bottom: '19%',
                            left: '6%',
                            right: '4%'
                        },
                        tooltip: {
                            trigger: 'axis',
                            label: {
                                show: true
                            }
                        },
                        color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
                        legend: {
                            icon: "circle",
                            data: ['总用户','新用户','老用户']
                        },
                        xAxis: {
                            boundaryGap: true, //默认，坐标轴留白策略
                            axisLine: {
                                show: false
                            },
                            splitLine: {
                                show: false
                            },
                            axisTick: {
                                show: false,
                                alignWithLabel: true
                            },
                            data: xAxis
                        },
                        yAxis: {
                            axisLine: {
                                show: false
                            },
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    type: 'dashed',
                                    color: 'rgba(33,148,246,0.2)'
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            splitArea: {
                                show: true,
                                areaStyle: {
                                    color: 'rgb(245,250,254)'
                                }
                            }
                        },
                        series:  [{
                            type: 'line',
                            name: this.$vuetify.lang.t('$vuetify.dashboard.all'),
                            data: data,
                            label: {
                              show:true,
                            }
                        },
                        ]
                        
                    })
                }

            }).finally(resp => {
                this.loading = false
            })
            

           
        },
      chartTimeChange(val) {
        if (this.groups_id == ''){
          Notification({
            type: 'error',
            message: '请选择集团'
          });
          return
        }
          this.drawPart3()
      },

      ConnectTimeChange() {
          if (this.group_id == ''){
            Notification({
              type: 'error',
              message: '请选择集团'
            });
            return
          }
          this.drawPart4()
      },

      drawPart3(){

        let myChart = Echarts.init(document.getElementById('myChart3'))
        this.chart3 = myChart
        this.$http.post(api.default.dashboard.dayauth, {authtime: this.authtime, group_id: this.groups_id}).then(resp => {
          if(!resp) return
          let data = []
          let xAxis = []
          // if(resp.data.length){
            for (let index = 0; index < resp.data.length; index++) {
              data.push(parseInt(resp.data[index]['count']))
              xAxis.push(resp.data[index]['date'])
            }
            myChart.setOption({
              backgroundColor: '#FFF',
              grid: {
                top: '9%',
                bottom: '19%',
                left: '6%',
                right: '4%'
              },
              tooltip: {
                trigger: 'axis',
                label: {
                  show: true
                }
              },
              color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
              legend: {
                icon: "circle",
                data: ['总用户','新用户','老用户']
              },
              xAxis: {
                boundaryGap: true, //默认，坐标轴留白策略
                axisLine: {
                  show: false
                },
                splitLine: {
                  show: false
                },
                axisTick: {
                  show: false,
                  alignWithLabel: true
                },
                data: xAxis
              },
              yAxis: {
                axisLine: {
                  show: false
                },
                splitLine: {
                  show: false,
                  lineStyle: {
                    type: 'dashed',
                    color: 'rgba(33,148,246,0.2)'
                  }
                },
                axisTick: {
                  show: false
                },
                splitArea: {
                  show: true,
                  areaStyle: {
                    color: 'rgb(245,250,254)'
                  }
                }
              },
              series:  [{
                type: 'line',
                name: this.$vuetify.lang.t('$vuetify.dashboard.all'),
                data: data,
                label: {
                  show:true,
                }
              },
              ]

            })
          // }

        }).finally(resp => {
          this.loading = false
        })
      },

      drawPart4(){

        let myChart = Echarts.init(document.getElementById('myChart4'))
        this.chart3 = myChart
        this.$http.post(api.default.dashboard.connectdayauth, {connecttime: this.connecttime, group_id: this.group_id}).then(resp => {
          if(!resp) return
          let data = []
          let xAxis = []
          // if(resp.data.length){
            for (let index = 0; index < resp.data.length; index++) {
              data.push(parseInt(resp.data[index]['total_count']))
              xAxis.push(resp.data[index]['date'])
            }
            myChart.setOption({
              backgroundColor: '#FFF',
              grid: {
                top: '9%',
                bottom: '19%',
                left: '6%',
                right: '4%'
              },
              tooltip: {
                trigger: 'axis',
                label: {
                  show: true
                }
              },
              color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
              legend: {
                icon: "circle",
                data: ['总用户','新用户','老用户']
              },
              xAxis: {
                boundaryGap: true, //默认，坐标轴留白策略
                axisLine: {
                  show: false
                },
                splitLine: {
                  show: false
                },
                axisTick: {
                  show: false,
                  alignWithLabel: true
                },
                data: xAxis
              },
              yAxis: {
                axisLine: {
                  show: false
                },
                splitLine: {
                  show: false,
                  lineStyle: {
                    type: 'dashed',
                    color: 'rgba(33,148,246,0.2)'
                  }
                },
                axisTick: {
                  show: false
                },
                splitArea: {
                  show: true,
                  areaStyle: {
                    color: 'rgb(245,250,254)'
                  }
                }
              },
              series:  [{
                type: 'line',
                name: this.$vuetify.lang.t('$vuetify.dashboard.all'),
                data: data,
                label: {
                  show:true,
                }
              },
              ]

            })
          // }

        }).finally(resp => {
          this.loading = false
        })
      },
        
        timpstapChange(unixtimestamp){
            var unixtimestamp = new Date(unixtimestamp);
            var year = 1900 + unixtimestamp.getYear();
            var month = "0" + (unixtimestamp.getMonth() + 1);
            var date = "0" + unixtimestamp.getDate();
            var hour = "0" + unixtimestamp.getHours();
            var minute = "0" + unixtimestamp.getMinutes();
            var second = "0" + unixtimestamp.getSeconds();
            return  year + "-" + month.substring(month.length-2, month.length)  + "-" + date.substring(date.length-2, date.length)
                + " " +  hour.substring(hour.length-2, hour.length) + ":"
                + minute.substring(minute.length-2, minute.length) + ":"
                + second.substring(second.length-2, second.length);
        },
        en_zh(en){
            switch (en) {
                case 'unknown':
                    return '未知流量'
                    break;
                case 'general':
                    return '常用协议'
                    break;
                case 'p2p':
                    return 'P2P下载'
                    break;
                case 'nettv':
                    return '网络电视'
                    break;
                case 'im':
                    return '即时通信'
                    break;
                case 'stream':
                    return '流媒体'
                    break;
                case 'voip':
                    return '网络电话'
                    break;
                case 'game':
                    return '网络游戏'
                    break;
                case 'stock':
                    return '股票交易'
                    break;
                case 'database':
                    return '数据库'
                    break;
                case 'other':
                    return '其他'
                    break;
                case 'httpgroup':
                    return 'HTTP协议'
                    break;
                case 'mobile':
                    return '移动应用'
                    break;
                case 'custom':
                    return '自定义协议'
                    break;
            
                default:
                    break;
            }
        },
        drawPart5(){

            let myChart5 = Echarts.init(document.getElementById('myChart5'))
            let myChart6 = Echarts.init(document.getElementById('myChart6'))
            let myChart7 = Echarts.init(document.getElementById('myChart7'))

            this.chart5 = myChart5
            this.chart6 = myChart6
            this.chart7 = myChart7

            this.$http.post(api.default.dashboard.upflow).then(resp => {
                // legendData5 = resp.data.name
                const rows = resp.data.rows

                let xAxis5 = []
                let legendData5 = []
                let series5 = []

                const legs = resp.data.rows[0]['data']
                for (let index = 0; index < legs.length; index++) {
                    const time = this.timpstapChange(legs[index]['x'])
                    xAxis5.push(time)
                }

                for (let index = 0; index < rows.length; index++) {
                    const dataArr = []
                    const name = this.en_zh(rows[index]['name'])
                    rows[index]['data'].forEach(element => {
                        dataArr.push(parseInt(element['y']))
                    });
                    series5.push({
                        type: 'line',
                        name: name,
                        data: dataArr
                    })
                    legendData5.push(name)
                }
                this.setChart5_6(myChart5,legendData5,xAxis5,series5,this.$vuetify.lang.t('$vuetify.common.flowdw'))

            }).finally(resp => {
                this.loading = false
            })

            this.$http.post(api.default.dashboard.downflow).then(resp => {
                // legendData5 = resp.data.name
                const rows = resp.data.rows

                let xAxis6 = []
                let legendData6 = []
                let series6 = []

                const legs = resp.data.rows[0]['data']
                for (let index = 0; index < legs.length; index++) {
                    const time = this.timpstapChange(legs[index]['x'])
                    xAxis6.push(time)
                }

                for (let index = 0; index < rows.length; index++) {
                    const dataArr = []
                    const name = this.en_zh(rows[index]['name'])
                    rows[index]['data'].forEach(element => {
                        dataArr.push(parseInt(element['y']))
                    });
                    series6.push({
                        type: 'line',
                        name: name,
                        data: dataArr
                    })
                    legendData6.push(name)
                }
                this.setChart5_6(myChart6,legendData6,xAxis6,series6,this.$vuetify.lang.t('$vuetify.common.flowdw'))

            }).finally(resp => {
                this.loading = false
            })

            this.$http.post(api.default.dashboard.conntrend).then(resp => {
                // legendData5 = resp.data.name
                if(!resp) return

                const rows = resp.data.rows

                let xAxis7 = []
                let legendData7 = []
                let series7 = []

                const legs = resp.data.rows[0]['data']
                for (let index = 0; index < legs.length; index++) {
                    const time = this.timpstapChange(legs[index]['x'])
                    xAxis7.push(time)
                }

                for (let index = 0; index < rows.length; index++) {
                    const dataArr = []
                    const name = this.en_zh(rows[index]['name'])
                    rows[index]['data'].forEach(element => {
                        dataArr.push(parseInt(element['y']))
                    });
                    series7.push({
                        type: 'line',
                        name: name,
                        data: dataArr
                    })
                    legendData7.push(name)
                }
                this.setChart7(myChart7,legendData7,xAxis7,series7,this.$vuetify.lang.t('$vuetify.common.flowcnt'))

            }).finally(resp => {
                this.loading = false
            })
        },

        setChart5_6(myChart,legendData,xAxis,series,dw){

            function bytesToSize(bytes) {
                if (bytes === 0) return '0 B';
                var k = 1000, // or 1024
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
            
                return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + (i>0?sizes[i]:'');
            }

            myChart.setOption({
                backgroundColor: '#FFF',
                grid: {
                    top: '25%',
                    bottom: '19%',
                    left: '10%',
                    right: '4%'
                },
                tooltip: {
                    trigger: 'axis',
                    label: {
                        show: true
                    },
                    formatter: function (params) {
                        let res = ''
                        let time = ''
                        for (let index = 0; index < params.length; index++) {
                            time = params[index].name
                            res += params[index].seriesName +":"+bytesToSize(params[index].data)+ '<br/>';
                        }
                        return time +"<br/>"+ res
                    }
                },
                color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
                legend: {
                    icon: "circle",
                    data: legendData
                },
                xAxis: {
                    boundaryGap: true, //默认，坐标轴留白策略
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false,
                        alignWithLabel: true
                    },
                    data: xAxis
                },
                yAxis: {
                    name:  dw,
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(33,148,246,0.2)'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: 'rgb(245,250,254)'
                        }
                    },
                    axisLabel:{
                        formatter: function (value,index) {
                            if(dw == 'flowcnt'){
                                return value
                            }else{
                                return bytesToSize(value);
                            }
                            
                        }
                    }
                    
                },
                series:  series
                
            })
        },
        setChart7(myChart,legendData,xAxis,series,dw){
            myChart.setOption({
                backgroundColor: '#FFF',
                grid: {
                    top: '25%',
                    bottom: '19%',
                    left: '10%',
                    right: '4%'
                },
                tooltip: {
                    trigger: 'axis',
                    label: {
                        show: true
                    },
                    formatter: function (params) {
                        let res = ''
                        let time = ''
                        for (let index = 0; index < params.length; index++) {
                            time = params[index].name
                            res += params[index].seriesName +":"+parseInt(params[index].data)+ '<br/>';
                        }
                        return time +"<br/>"+ res
                    }
                },
                color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
                legend: {
                    icon: "circle",
                    data: legendData
                },
                xAxis: {
                    boundaryGap: true, //默认，坐标轴留白策略
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false,
                        alignWithLabel: true
                    },
                    data: xAxis
                },
                yAxis: {
                    name:  dw,
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(33,148,246,0.2)'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: 'rgb(245,250,254)'
                        }
                    },
                    axisLabel:{
                        formatter: function (value,index) {
                                return value;
                            
                        }
                    }
                    
                },
                series:  series
                
            })
        },

        // // 备用
        // drawChart3_all() {
        //     let legendData1 = ['淘宝','2','3','4','5']
        //     let legendData2 = ['认证用户']
        //     let xAxisData2 = ['0-6点','6-12点','12-18点','18-24点']
        //     let top5 = ['38号点（1）', '38号点（2）', '15号点', '16号点', '24号点']
        //     let data1 = [
        //         {value: 335, name: '淘宝'},
        //         {value: 310, name: '2'},
        //         {value: 234, name: '3'},
        //         {value: 135, name: '4'},
        //         {value: 1548, name: '5'}
        //     ]
        //     let data2 = [{
        //             type: 'bar',
        //             name: '认证用户',
        //             data: [
        //                 2000, 1800, 2800, 900, 1600, 2000,
        //             ]
        //         }
        //     ]
        //     let data3 = [
        //         {value: 335, name: '0~2小时'},
        //         {value: 310, name: '2~4小时'},
        //         {value: 234, name: '4~6小时'},
        //         {value: 135, name: '6~8小时'},
        //         {value: 48, name: '8~'}
        //     ]
        //     let data4 = [
        //         {value: 335, name: 'Mac'},
        //         {value: 310, name: 'Android'},
        //         {value: 234, name: 'windows'},
        //         {value: 135, name: 'ios'}
        //     ]
        //     let data5 = [7500, 6200, 5700, 4200, 3500]

        //     this.drawChart3_1(legendData1,data1)
        //     this.drawChart3_2(legendData2,xAxisData2,data2)
        //     this.drawChart3_3(data3)
        //     this.drawChart3_4(data4)
        //     this.drawChart3_5(top5,data5)
            
        // },
        // drawChart4_all() {
        //     let legendData1 = ['0-6点','6-12点','12-14点','14-20点','20-0点']
        //     let legendData2 = ['http','www','其他']
        //     let xAxisData2 = ['0-8点','8-16点','16-24点']
        //     let top5 = ['http', 'https', '其他']
        //     let data1 = [
        //         {value: 36, name: '0-6点'},
        //         {value: 24, name: '6-12点'},
        //         {value: 24, name: '12-14点'},
        //         {value: 35, name: '14-20点'},
        //         {value: 48, name: '20-0点'}
        //     ]
        //     let data2 = [{
        //             type: 'bar',
        //             name: 'http',
        //             data: [
        //                 2000, 1800, 2800, 900, 1600, 2000,
        //             ]
        //         },{
        //             type: 'bar',
        //             name: 'www',
        //             data: [
        //                 1000, 1400, 1000, 1900, 2600, 2000,
        //             ]
        //         },{
        //             type: 'bar',
        //             name: '其他',
        //             data: [
        //                 900, 400, 200, 300, 600, 900,
        //             ]
        //         },
        //     ]
        //     let data3 = [
        //         {value: 335, name: '微信'},
        //         {value: 310, name: '手机'},
        //         {value: 234, name: 'radius对接'},
        //     ]
        //     let data4 = [
        //         {value: 335, name: 'Mac'},
        //         {value: 310, name: 'Android'},
        //         {value: 234, name: 'windows'},
        //         {value: 135, name: 'ios'}
        //     ]
        //     let data5 = [7500, 6200, 5700]

        //     this.drawChart4_1(legendData1,data1)
        //     this.drawChart4_2(legendData2,xAxisData2,data2)
        //     this.drawChart4_3(data3)
        //     this.drawChart4_4(data4)
        //     this.drawChart4_5(top5,data5)
        // },
        // //分
        // drawChart3_1(legendData,data) {
        //     this.chart = Echarts.init(document.getElementById('myChart3_1'));
        //     this.chart.clear();

        //     const optionData = {
        //         title: {
        //             text: this.$vuetify.lang.t('$vuetify.dashboard.myChart3_1_title'),
        //             left:'48%',
        //             top:'0%',
        //             textAlign:'center',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14,
        //             }
                    
        //         },
        //         color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{b}: {c} ({d}%)'
        //         },
        //         legend: {
        //             icon: "circle",
        //             textStyle:{
        //                 fontSize: 12,
        //                 color: '#8a8a8a',
        //                 fontFamily: 'Microsoft YaHei'
        //             },
        //             bottom: 0,
        //             data: legendData
        //         },
        //         series: [
        //             {
        //                 barMinWidth: 50,
        //                 barMinHeight: 50,
        //                 name: '',
        //                 type: 'pie',
        //                 radius: ['32%', '45%'],
        //                 avoidLabelOverlap: false,
        //                 label: {
        //                     normal: {
        //                         show: false,
        //                         position: 'center'
        //                     },
        //                     emphasis: {
        //                         show: true,
        //                         textStyle: {
        //                             fontSize: '30',
        //                             fontWeight: 'bold'
        //                         }
        //                     }
        //                 },
        //                 labelLine: {
        //                     normal: {
        //                         show: false
        //                     }
        //                 },
        //                 data: data
        //             }
        //         ]
        //     };

        //     this.chart.setOption(optionData);
        // },
        // drawChart3_2 (legendData,xAxisData,data) {
        //     let myChart = Echarts.init(document.getElementById('myChart3_2'))

        //     myChart.setOption({
        //         title: {
        //             text: this.$vuetify.lang.t('$vuetify.dashboard.myChart3_2_title'),
        //             left:'48%',
        //             top:'0%',
        //             textAlign:'center',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14
        //             }
        //         },
        //         backgroundColor: '#FFF',
        //         grid: {
        //             left: '3%',
        //             right: '4%',
        //             bottom: '20%',
        //             containLabel: true
        //         },
        //         tooltip: {
        //             trigger: 'axis',
        //             label: {
        //                 show: true
        //             }
        //         },
        //         color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
        //         legend: {
        //             icon: "circle",
        //             textStyle:{
        //                 color: '#8a8a8a',
        //                 fontSize: 12,
        //             },
        //             bottom: 0,
        //             data: legendData
        //         },
        //         xAxis: {
        //             boundaryGap: true, //默认，坐标轴留白策略
        //             axisLine: {
        //                 show: false
        //             },
        //             splitLine: {
        //                 show: false
        //             },
        //             axisTick: {
        //                 show: false,
        //                 alignWithLabel: true
        //             },
        //             data: xAxisData
        //         },
        //         yAxis: {
        //             axisLine: {
        //                 show: false
        //             },
        //             splitLine: {
        //                 show: false,
        //                 lineStyle: {
        //                     type: 'dashed',
        //                     color: 'rgba(33,148,246,0.2)'
        //                 }
        //             },
        //             axisTick: {
        //                 show: false
        //             },
        //             splitArea: {
        //                 show: true,
        //                 areaStyle: {
        //                     color: 'rgb(245,250,254)'
        //                 }
        //             }
        //         },
        //         series:  data
                
        //     })
        // },
        // drawChart3_3 (data) {
        //     this.chart = Echarts.init(document.getElementById('myChart3_3'));
        //     this.chart.clear();

        //     const optionData = {
        //         title: {
        //             text: '',
        //             top:'0%',
        //             textAlign:'left',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14,
        //             }
        //         },
        //         grid: {
        //             left: 55,
        //         },
        //         color:['#cdcf9b','#bc9e78','#98c1ef','#564e7d','#5bd16b','#e63995'],
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{b}: {c} ({d}%)'
        //         },
        //         series: [
        //             {
        //                 barMaxWidth: 20,
        //                 barMaxHeight: 20,
        //                 type: 'pie',
        //                 radius: ['23%', '35%'],
        //                 avoidLabelOverlap: false,
        //                 data: data
        //             }
        //         ]
        //     };

        //     this.chart.setOption(optionData);
        // },
        // drawChart3_4 (data) {
        //     this.chart = Echarts.init(document.getElementById('myChart3_4'));
        //     this.chart.clear();

        //     const optionData = {
        //         title: {
        //             text: '',
        //             top:'0%',
        //             textAlign:'left',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14,
        //             }
        //         },
        //         grid: {
        //             left: 55,
        //         },
        //         color:['#cdcf9b','#bc9e78','#98c1ef','#564e7d','#5bd16b','#e63995'],
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{b}: {c} ({d}%)'
        //         },
        //         series: [
        //             {
        //                 barMaxWidth: 20,
        //                 barMaxHeight: 20,
        //                 type: 'pie',
        //                 radius: ['23%', '35%'],
        //                 avoidLabelOverlap: false,
        //                 data: data
        //             }
        //         ]
        //     };

        //     this.chart.setOption(optionData);
        // },
        // drawChart3_5(cityList,chartData) {
        //     this.chart = Echarts.init(document.getElementById('myChart3_5'));
        //     this.chart.clear();

        //     var charts = { // 按顺序排列从大到小
        //         cityList: cityList,
        //         cityData: chartData
        //     }
        //     var top10CityList = charts.cityList
        //     var top10CityData = charts.cityData
        //     var color = ['rgba(255,0,0', 'rgba(255,0,0', 'rgba(255,0,0', 'rgba(255,0,0', 'rgba(255,0,0']

        //     let lineY = []
        //     for (var i = 0; i < charts.cityList.length; i++) {
        //     var x = i
        //     if (x > color.length - 1) {
        //         x = color.length - 1
        //     }
        //     var data = {
        //         name: charts.cityList[i],
        //         color: color[x] + ')',
        //         value: top10CityData[i],
        //         itemStyle: {
        //         normal: {
        //             show: true,
        //             color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [{
        //             offset: 0,
        //             color: color[x] + ', 1)'
        //             }, {
        //             offset: 1,
        //             color: color[x] + ', 0.3)'
        //             }], false),
        //             barBorderRadius: 10
        //         },
        //         emphasis: {
        //             shadowBlur: 15,
        //             shadowColor: 'rgba(0, 0, 0, 0.1)'
        //         }
        //         }
        //     }
        //     lineY.push(data)
        //     }

        //     const optionData = {
        //         title: {
        //             show: false
        //         },
        //         tooltip: {
        //             trigger: 'item'
        //         },
        //         grid: {
        //             borderWidth: 0,
        //             top: '10%',
        //             left: '0%',
        //             right: '15%',
        //             bottom: '3%'
        //         },
        //         color: color,
        //         yAxis: [{
        //             type: 'category',
        //             inverse: true,
        //             axisTick: {
        //             show: false
        //             },
        //             axisLine: {
        //             show: false
        //             },
        //             axisLabel: {
        //             show: false,
        //             inside: false
        //             },
        //             data: top10CityList
        //         }, {
        //             type: 'category',
        //             axisLine: {
        //             show: false
        //             },
        //             axisTick: {
        //             show: false
        //             },
        //             axisLabel: {
        //             show: false,
        //             inside: false,
        //             textStyle: {
        //                 color: '#4D4D4D',
        //                 fontSize: '12',
        //                 fontFamily: 'PingFangSC-Regular'
        //             },
        //             formatter: function (val) {
        //                 return `${val}k`
        //             }
        //             },
        //             splitArea: {
        //             show: false
        //             },
        //             splitLine: {
        //             show: false
        //             },
        //             data: top10CityData
        //         }],
        //         xAxis: {
        //             type: 'value',
        //             axisTick: {
        //             show: false
        //             },
        //             axisLine: {
        //             show: false
        //             },
        //             splitLine: {
        //             show: false
        //             },
        //             axisLabel: {
        //             show: false
        //             }
        //         },
        //         series: [{
        //             name: '',
        //             type: 'bar',
        //             zlevel: 2,
        //             barWidth: '8px',
        //             data: lineY,
        //             animationDuration: 1500,
        //             label: {
        //             normal: {
        //                 color: '#4D4D4D',
        //                 show: true,
        //                 position: [0, '-24px'],
        //                 textStyle: {
        //                 fontSize: 12
        //                 },
        //                 formatter: function (a, b) {
        //                 return a.name
        //                 }
        //             }
        //             }
        //         }],
        //         animationEasing: 'cubicOut'
        //     }
        //     this.chart.setOption(optionData);
        // },
        // drawChart4_1(legendData,data) {
        //     this.chart = Echarts.init(document.getElementById('myChart4_1'));
        //     this.chart.clear();

        //     const optionData = {
        //         title: {
        //             text: this.$vuetify.lang.t('$vuetify.dashboard.myChart4_1_title'),
        //             left:'48%',
        //             top:'0%',
        //             textAlign:'center',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14,
        //             }
                    
        //         },
        //         color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{b}: {c} ({d}%)'
        //         },
        //         legend: {
        //             icon: "circle",
        //             textStyle:{
        //                 fontSize: 12,
        //                 color: '#8a8a8a',
        //                 fontFamily: 'Microsoft YaHei'
        //             },
        //             bottom: 0,
        //             data: legendData
        //         },
        //         series: [
        //             {
        //                 barMinWidth: 50,
        //                 barMinHeight: 50,
        //                 name: '',
        //                 type: 'pie',
        //                 radius: ['32%', '45%'],
        //                 avoidLabelOverlap: false,
        //                 label: {
        //                     normal: {
        //                         show: false,
        //                         position: 'center'
        //                     },
        //                     emphasis: {
        //                         show: true,
        //                         textStyle: {
        //                             fontSize: '30',
        //                             fontWeight: 'bold'
        //                         }
        //                     }
        //                 },
        //                 labelLine: {
        //                     normal: {
        //                         show: false
        //                     }
        //                 },
        //                 data: data
        //             }
        //         ]
        //     };

        //     this.chart.setOption(optionData);
        // },
        // drawChart4_2 (legendData,xAxisData,data) {
        //     let myChart = Echarts.init(document.getElementById('myChart4_2'))

        //     myChart.setOption({
        //         title: {
        //             text: this.$vuetify.lang.t('$vuetify.dashboard.myChart4_2_title'),
        //             left:'48%',
        //             top:'0%',
        //             textAlign:'center',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14
        //             }
        //         },
        //         backgroundColor: '#FFF',
        //         grid: {
        //             left: '3%',
        //             right: '4%',
        //             bottom: '20%',
        //             containLabel: true
        //         },
        //         tooltip: {
        //             trigger: 'axis',
        //             label: {
        //                 show: true
        //             }
        //         },
        //         color:['#7986CB','#81C784','#64B5F6','#4DB6AC','#4DD0E1','#AED581','#9575CD'],
        //         legend: {
        //             icon: "circle",
        //             textStyle:{
        //                 color: '#8a8a8a',
        //                 fontSize: 12,
        //             },
        //             bottom: 0,
        //             data: legendData
        //         },
        //         xAxis: {
        //             boundaryGap: true, //默认，坐标轴留白策略
        //             axisLine: {
        //                 show: false
        //             },
        //             splitLine: {
        //                 show: false
        //             },
        //             axisTick: {
        //                 show: false,
        //                 alignWithLabel: true
        //             },
        //             data: xAxisData
        //         },
        //         yAxis: {
        //             axisLine: {
        //                 show: false
        //             },
        //             splitLine: {
        //                 show: false,
        //                 lineStyle: {
        //                     type: 'dashed',
        //                     color: 'rgba(33,148,246,0.2)'
        //                 }
        //             },
        //             axisTick: {
        //                 show: false
        //             },
        //             splitArea: {
        //                 show: true,
        //                 areaStyle: {
        //                     color: 'rgb(245,250,254)'
        //                 }
        //             }
        //         },
        //         series:  data
                
        //     })
        // },
        // drawChart4_3 (data) {
        //     this.chart = Echarts.init(document.getElementById('myChart4_3'));
        //     this.chart.clear();

        //     const optionData = {
        //         title: {
        //             text: '',
        //             top:'0%',
        //             textAlign:'left',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14,
        //             }
        //         },
        //         grid: {
        //             left: 55,
        //         },
        //         color:['#cdcf9b','#bc9e78','#98c1ef','#564e7d','#5bd16b','#e63995'],
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{b}: {c} ({d}%)'
        //         },
        //         series: [
        //             {
        //                 barMaxWidth: 20,
        //                 barMaxHeight: 20,
        //                 type: 'pie',
        //                 radius: ['23%', '35%'],
        //                 avoidLabelOverlap: false,
        //                 data: data
        //             }
        //         ]
        //     };

        //     this.chart.setOption(optionData);
        // },
        // drawChart4_4 (data) {
        //     this.chart = Echarts.init(document.getElementById('myChart4_4'));
        //     this.chart.clear();

        //     const optionData = {
        //         title: {
        //             text: '',
        //             top:'0%',
        //             textAlign:'left',
        //             fontFamily: 'Microsoft YaHei',
        //             textStyle: {
        //                 fontSize:14,
        //             }
        //         },
        //         grid: {
        //             left: 55,
        //         },
        //         color:['#cdcf9b','#bc9e78','#98c1ef','#564e7d','#5bd16b','#e63995'],
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{b}: {c} ({d}%)'
        //         },
        //         series: [
        //             {
        //                 barMaxWidth: 20,
        //                 barMaxHeight: 20,
        //                 type: 'pie',
        //                 radius: ['23%', '35%'],
        //                 avoidLabelOverlap: false,
        //                 data: data
        //             }
        //         ]
        //     };

        //     this.chart.setOption(optionData);
        // },
        // drawChart4_5(cityList,chartData) {
        //     this.chart = Echarts.init(document.getElementById('myChart4_5'));
        //     this.chart.clear();

        //     var charts = { // 按顺序排列从大到小
        //         cityList: cityList,
        //         cityData: chartData
        //     }
        //     var top10CityList = charts.cityList
        //     var top10CityData = charts.cityData
        //     var color = ['rgba(255,0,0', 'rgba(255,0,0', 'rgba(255,0,0', 'rgba(255,0,0', 'rgba(255,0,0']

        //     let lineY = []
        //     for (var i = 0; i < charts.cityList.length; i++) {
        //     var x = i
        //     if (x > color.length - 1) {
        //         x = color.length - 1
        //     }
        //     var data = {
        //         name: charts.cityList[i],
        //         color: color[x] + ')',
        //         value: top10CityData[i],
        //         itemStyle: {
        //         normal: {
        //             show: true,
        //             color: new Echarts.graphic.LinearGradient(0, 0, 1, 0, [{
        //             offset: 0,
        //             color: color[x] + ', 1)'
        //             }, {
        //             offset: 1,
        //             color: color[x] + ', 0.3)'
        //             }], false),
        //             barBorderRadius: 10
        //         },
        //         emphasis: {
        //             shadowBlur: 15,
        //             shadowColor: 'rgba(0, 0, 0, 0.1)'
        //         }
        //         }
        //     }
        //     lineY.push(data)
        //     }

        //     const optionData = {
        //         title: {
        //             show: false
        //         },
        //         tooltip: {
        //             trigger: 'item'
        //         },
        //         grid: {
        //             borderWidth: 0,
        //             top: '10%',
        //             left: '0%',
        //             right: '15%',
        //             bottom: '3%'
        //         },
        //         color: color,
        //         yAxis: [{
        //             type: 'category',
        //             inverse: true,
        //             axisTick: {
        //             show: false
        //             },
        //             axisLine: {
        //             show: false
        //             },
        //             axisLabel: {
        //             show: false,
        //             inside: false
        //             },
        //             data: top10CityList
        //         }, {
        //             type: 'category',
        //             axisLine: {
        //             show: false
        //             },
        //             axisTick: {
        //             show: false
        //             },
        //             axisLabel: {
        //             show: false,
        //             inside: false,
        //             textStyle: {
        //                 color: '#4D4D4D',
        //                 fontSize: '12',
        //                 fontFamily: 'PingFangSC-Regular'
        //             },
        //             formatter: function (val) {
        //                 return `${val}k`
        //             }
        //             },
        //             splitArea: {
        //             show: false
        //             },
        //             splitLine: {
        //             show: false
        //             },
        //             data: top10CityData
        //         }],
        //         xAxis: {
        //             type: 'value',
        //             axisTick: {
        //             show: false
        //             },
        //             axisLine: {
        //             show: false
        //             },
        //             splitLine: {
        //             show: false
        //             },
        //             axisLabel: {
        //             show: false
        //             }
        //         },
        //         series: [{
        //             name: '',
        //             type: 'bar',
        //             zlevel: 2,
        //             barWidth: '8px',
        //             data: lineY,
        //             animationDuration: 1500,
        //             label: {
        //             normal: {
        //                 color: '#4D4D4D',
        //                 show: true,
        //                 position: [0, '-24px'],
        //                 textStyle: {
        //                 fontSize: 12
        //                 },
        //                 formatter: function (a, b) {
        //                 return a.name
        //                 }
        //             }
        //             }
        //         }],
        //         animationEasing: 'cubicOut'
        //     }
        //     this.chart.setOption(optionData);
        // },
    }
}
</script>

<style scoped>

.main_lay {
    margin: 0 24px;
    min-height: 90%;
    padding-bottom: 20px;
}

.count {
    font-size: 25px;
    color: #5C6269;
    font-weight: 600;
}
.count_white {
    font-size: 35px;
    color: #fff;
    font-weight: 400;
}
.font-weight-medium {
    color: #5C6269;
    margin-bottom: -35px;
}
.font-weight-medium-white {
    color: #fff;
    margin-bottom: -35px;
}
.font-divider {
    margin-bottom: -35px;
}

.blue_title{
    width: 4px;
    height: 12px;
    display: inline-block;
    background:#4477FF;
}

.blue_top1 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#4477FF;
}
.blue_top2 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#3BA6EE;
}
.blue_top3 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#21D1E3;
}
.blue_top4 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#21D1E3;
}
.blue_top5 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#21D1E3;
}

.red_top1 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#F15251;
}
.red_top2 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#E98368;
}
.red_top3 {
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
    margin-bottom: 2px;
    background:#ECDB63;
}


</style>

<style lang="scss">
  .v-card--material-chart {
    .v-card--material__header {
      .ct-label {
        color: inherit;
        opacity: .7;
        font-size: 0.975rem;
        font-weight: 100;
      }

      .ct-grid{
        stroke: rgba(255, 255, 255, 0.2);
      }
      .ct-series-a .ct-point,
      .ct-series-a .ct-line,
      .ct-series-a .ct-bar,
      .ct-series-a .ct-slice-donut {
          stroke: rgba(255,255,255,.8);
      }
      .ct-series-a .ct-slice-pie,
      .ct-series-a .ct-area {
          fill: rgba(255,255,255,.4);
      }
    }
  }
  .flow_name {
    font-size: 12px;
    color: #646A70;
    margin-right: 15px;
    width: 27px;
    display: inline-block;
}
</style>